import { Circle, type TextProps, type ThemeName } from "tamagui";
import type { IconProps } from "@tamagui/helpers-icon";
import { hairline } from "../utils/hairline";
import { type StackProps, XStack } from "./Stacks";
import { Paragraph2 } from "./Typography";
export type PillProps = {
  text: string;
  notificationDot?: boolean;
  theme?: ThemeName;
  wrapperProps?: StackProps;
  textProps?: TextProps;
  leftIcon?: React.ComponentType<IconProps>;
  leftIconProps?: IconProps;
  rightIcon?: React.ComponentType<IconProps>;
  rightIconProps?: IconProps;
};
export const Pill = ({
  text,
  notificationDot,
  theme = "alt1",
  wrapperProps,
  textProps,
  leftIcon: LeftIcon,
  leftIconProps,
  rightIcon: RightIcon,
  rightIconProps
}: PillProps) => {
  return <XStack theme={theme} ai="center" jc="space-evenly" br="$3"
  // No matching tokens
  px={6} py={4} bg="$color3" gap={6} borderWidth={hairline} borderColor="$color4" {...wrapperProps} data-sentry-element="XStack" data-sentry-component="Pill" data-sentry-source-file="Pill.tsx">
      {LeftIcon ? <LeftIcon {...leftIconProps} /> : null}
      {notificationDot ? <Circle height={5} width={5} zi={2} backgroundColor="$color13" /> : null}
      <Paragraph2 color="$color" zi={2} {...textProps} data-sentry-element="Paragraph2" data-sentry-source-file="Pill.tsx">
        {text}
      </Paragraph2>
      {RightIcon ? <RightIcon {...rightIconProps} /> : null}
    </XStack>;
};